import { createNewArray } from "@/shared/libs/array-utils";
import Box from "./Box";
import Flex from "./Flex";
import List from "./List";
import { cn } from "@/shared/libs/commonUtils";

interface PulseProps {
  color?: "primary" | "secondary" | "background" | "foreground";
}

const theme = {
  color: {
    primary: "bg-primary",
    secondary: "bg-secondary",
    background: "bg-background dark:bg-foreground",
    foreground: "bg-foreground",
  },
};

function Pulse({ color = "background" }: PulseProps) {
  return (
    <Flex className="size-3 relative gap-x-3 justify-center">
      <List
        items={createNewArray(3, 3)}
        renderItems={() => (
          <Box>
            <Box
              className={cn(
                "animate-ping delay-0 !absolute inline-flex h-full w-full rounded-full opacity-75",
                color ? theme.color[color] : "bg-background dark:bg-foreground",
              )}
            />
            <Box
              className={cn(
                "size-3 inline-flex rounded-full",
                color ? theme.color[color] : "bg-background dark:bg-foreground",
              )}
            />
          </Box>
        )}
      />
    </Flex>
  );
}

export { Pulse };
